import { PublicUser } from '../types/PublicUser'

/**
 * Extracts UID from current URL (last segment).
 */
function extractUidFromUrl(): string | null {
	const segments = window.location.pathname.split('/').filter(Boolean)
	const uid = segments[segments.length - 1]
	return uid?.trim() || null
}

/**
 * Fetches public user data from backend using UID from the URL.
 */
export async function getUserDataForFrontend(): Promise<PublicUser | null> {
	const uid = extractUidFromUrl()
	if (!uid) {
		console.warn('No UID found in the URL.')
		return null
	}

	const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/v1/user/by-uid/${uid}`

	try {
		const response = await fetch(endpoint, {
			headers: {
				'Content-Type': 'application/json',
			},
		})

		const data = await response.json()

		if (!data.success || !data.result) {
			console.error('User fetch failed:', data.message || 'Unknown error')
			return null
		}

		return data.result as PublicUser
	} catch (error) {
		console.error('Fetch error while retrieving user:', error)
		return null
	}
}
